module.exports = __webpack_public_path__ + "img/mail.efeab80e.svg";